// src/components/layout/SidebarContent.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ViewSidebar,
  Search,
  History,
  PersonOutline,
  HelpOutline,
  SettingsOutlined,
  Logout,
} from "@mui/icons-material";

type Props = {
  variant: "expanded" | "collapsed" | "drawer";
  onToggle?: () => void;
  onNavigate?: () => void; // Drawerを閉じたい時に呼ぶ
};

const SidebarContent: React.FC<Props> = ({ variant, onToggle, onNavigate }) => {
  const navigate = useNavigate();
  const isCompact = variant === "collapsed";
  const showLabels = variant !== "collapsed";

  const go = (path: string) => {
    navigate(path);
    onNavigate?.();
  };

  if (isCompact) {
    return (
      <div className="flex flex-col items-center justify-between py-4 h-full">
        <div className="flex flex-col items-center space-y-6">
          <div className="w-6 h-6 rounded bg-black" />
          <button onClick={onToggle}>
            <ViewSidebar fontSize="small" />
          </button>
          <button onClick={() => go("/search-intro")}>
            <Search fontSize="small" />
          </button>
          <History fontSize="small" />
        </div>
        <div className="flex flex-col items-center space-y-6">
          <button onClick={() => go("/settings")}>
            <SettingsOutlined fontSize="small" />
          </button>
          <Logout fontSize="small" />
          <PersonOutline fontSize="small" />
          <HelpOutline fontSize="small" />
        </div>
      </div>
    );
  }

  // expanded / drawer
  return (
    <div className="flex flex-col justify-between h-full py-4">
      <div>
        <div className="h-5 mb-6" />
        <ul className="space-y-2">
          {onToggle && (
            <li
              className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={onToggle}
            >
              <ViewSidebar className="mr-3" />
              {showLabels && <span></span>}
            </li>
          )}
          <li
            className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
            onClick={() => go("/search-intro")}
          >
            <Search className="mr-3" />
            {showLabels && <span>検索</span>}
          </li>
          <li className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
            <History className="mr-3" />
            {showLabels && <span>履歴</span>}
          </li>
        </ul>
      </div>

      <div className="space-y-2">
        <div
          className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => go("/settings")}
        >
          <SettingsOutlined className="mr-3" />
          {showLabels && <span>個人設定</span>}
        </div>

        <div
          className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => go("/logout")}
        >
          <Logout className="mr-3" />
          {showLabels && <span>ログアウト</span>}
        </div>
        <div className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
          <PersonOutline className="mr-3" />
          {showLabels && <span>プロフィール</span>}
        </div>
        <div className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
          <HelpOutline className="mr-3" />
          {showLabels && <span>ヘルプ</span>}
        </div>
      </div>
    </div>
  );
};

export default SidebarContent;